import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const STORAGE_KEY = "mimo-pata-cart-v1";
const CartContext = createContext(null);

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) ?? [];
        } catch {
            return [];
        }
    });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        try {
            window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
        } catch {
            /* noop */
        }
    }, [items]);

    const add = useCallback((product) => {
        setItems((prev) => {
            const found = prev.find((i) => i.id === product.id);
            if (found) {
                return prev.map((i) => (i.id === product.id ? { ...i, qty: i.qty + 1 } : i));
            }
            return [
                ...prev,
                { id: product.id, name: product.name, price: product.price, image: product.image, qty: 1 },
            ];
        });
        toast.success(`${product.name} entrou na cesta`, {
            description: "Carrinho demonstrativo — nada é cobrado.",
        });
    }, []);

    const setQty = useCallback((id, qty) => {
        setItems((prev) =>
            qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty } : i)),
        );
    }, []);

    const remove = useCallback((id) => {
        setItems((prev) => prev.filter((i) => i.id !== id));
        toast.info("Item removido da cesta demo");
    }, []);

    const clear = useCallback(() => {
        setItems([]);
        toast.info("Cesta esvaziada");
    }, []);

    const count = useMemo(() => items.reduce((acc, i) => acc + i.qty, 0), [items]);
    const subtotal = useMemo(() => items.reduce((acc, i) => acc + i.qty * i.price, 0), [items]);

    const value = useMemo(
        () => ({ items, add, setQty, remove, clear, count, subtotal, open, setOpen }),
        [items, add, setQty, remove, clear, count, subtotal, open],
    );

    return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
